<template>
  <div>
      <v-row dense>
        <v-col sm="11">
        </v-col>
        <v-col align="Right" sm="1">
          <v-menu open-on-hover top offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-icon color="orange" small v-bind="attrs" v-on="on"
                >mdi-help</v-icon
              >
            </template>
            <v-list>
              <v-list-item>
                <a
                  :href="HelpSearchBySample"
                  title="About This Page"
                  target="limsds_help"
                  >About This Page</a
                ></v-list-item
              >
              <v-list-item
                ><a
                  :href="NewsLetter"
                  title="Newsletter Index"
                  target="limsds_help"
                  >Newsletter Index</a
                ></v-list-item
              >
            </v-list>
          </v-menu>
        </v-col>
      </v-row>
      <v-row dense>
        <v-col sm="3">
          <v-select
            outlined
            hide-details
            dense
            label="Select Site"
            v-model="list.site1"
            :items="SiteList"
            item-text="site"
            item-value="site"
          ></v-select>
        </v-col>
      </v-row>
      <v-row dense>
        <v-col sm="3">
          <v-text-field
            v-model="previousDay"
            dense
            outlined
            hide-details
            label="Previous Days"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row dense>
        <v-col sm="1">
          <v-select
            outlined
            hide-details
            dense
            label="Sample Point"
            v-model="DDSamplePoint"
            :items="itemsCommonDD"
            item-text="name"
            item-value="id"
          ></v-select>
        </v-col>
        <v-col sm="2">
          <v-autocomplete
            v-model="SamplePoint"
            :items="SamplePointList"
            item-text="point"
            item-value="d_key"
            dense
            outlined
            hide-details
            filled
            label="Sample Point"
          ></v-autocomplete>
        </v-col>
      </v-row>
      <v-row dense>
        <v-col sm="3">
          <v-checkbox
            dense
            v-model="isFailuer"
            hide-details
            :label="`Failuers Only`"
          ></v-checkbox>
        </v-col>
      </v-row>   
      <v-row dense>
        <v-col sm="2">
          <v-btn
            rounded
            dense
            outlined
            hide-details
            color="primary"
            dark
            @click="fetchLogDetails()"
            >Get Logs
          </v-btn>
        </v-col>
       
      </v-row>
      <v-row>
        <v-col></v-col>
      </v-row>
    
  </div>
</template>
<script>
import axios from "axios";
import uiView from "@/_mixins/ui-view-mixin";
import appMixin from "../mixins/app-mixin";
export default {
  name: "TransmssionLog",
  mixins: [uiView, appMixin],
  components: {},

  created() {},
  mounted() {
    let that = this;
    const SiteLink =
      that.settings.WASite + "UserID=" + that.userId;
    axios.get(SiteLink).then((response) => {
      this.SiteList = response.data.enumSiteLists;
    });

    that.NewsLetter = that.settings.NewsLetter;
    that.HelpSearchBySample = that.settings.HelpSearchBySample;
    const UserPreferenceLink =
      that.settings.WAPreferenceByUser + "UserID=" + that.userId;
      axios.get(UserPreferenceLink).then((response) => {
      that.list = response.data.value[0];
      that.FillSamplePointDropDown();
    });

  },
  data() {
    return {
    userId: "LYONDELL\\axyadav1",
    previousDay:1,
    HelpSearchBySample:null,
    NewsLetter:null,
    SamplePointList: undefined,
    DDSamplePoint: 1,
    SamplePoint: "",
    SamplePointAPI: "%",
    itemsCommonDD: [
      { name: "Contains", id: 1 },
      { name: "Start With", id: 2 },
      { name: "Exact", id: 3 },
    ],
    isFailuer:"1",
    SiteList: null,
    logResult: null,
    list: {},
    };
  },
  methods: {
      fetchLogDetails()
      {

      },
    FillSamplePointDropDown() {
      const SampleListLink =
        this.settings.WASampleListWithDesc +
        "site=" +
        this.list.site1 +
        "&unit=" +"" +
        "&area=" +"" +
        "&pointmask=%&descmask=%&userid=" +
        this.userid +
        "&lims_internal=0&earliest_date=2020-05-11 00:00:00";
      axios.get(SampleListLink).then((response) => {
        this.SamplePointList = response.data.value;
      });
    },
  }
};
</script>
<style lang="scss">
.v-input input {
  max-height: 15px;
}
</style>

